import React, { useEffect, useState } from 'react'
import { useRoutes, Navigate, useLocation } from 'react-router-dom'

import AdminUsers from './components/Admin/AdminUsers'
import AnalyticsDashboard from './components/AnalyticsDashboard/AnalyticsDashboard.js'
import Loadboard from './components/Loadboard/LoadBoardMain.js'
import Login from './components/AuthPages/Login.js'
import SignUp from './components/AuthPages/SignUp.js'
import Policy from './components/Policies/Policy.js'
import Terms from './components/Policies/Terms.js'

import Settings from './components/Settings/SettingsMain.js'
import PaymentPage from './components/Payment/Payment.js'
import PaymentSuccess from './components/PaymentSuccess/PaymentSuccess.js'
import LandinPage from './components/LandingPage/LandingPage.js'
import UninstallFeedback from './components/UninstallExtention/UninstallFeedback.js'
import PasswordResetRequest from './components/AuthPages/PasswordResetRequest.js'
import PasswordReset from './components/AuthPages/PasswordReset.js'
import LoginPrompt from './components/AuthPages/LoginPromptExtension.js'

import auth from './services/authService'

function ProtectedRoute({ condition, element }) {
	const location = useLocation()

	return condition ? (
		element
	) : (
		<Navigate to={`/account/login${location.search}`} />
	)
}

function AuthRedirect({ condition, element }) {
	const location = useLocation()

	return condition ? (
		<Navigate to={`/loadboard${location.search}`} replace />
	) : (
		element
	)
}

function Routes() {
	const user = auth.getCurrentUser()
	const isAdmin = user?.isAdmin
	const location = useLocation()

	const [sourceExtension, setSourceExtension] = useState(false)
	const [showLoginPrompt, setShowLoginPrompt] = useState(false)
	const [token, setToken] = useState('')

	useEffect(() => {
		const params = new URLSearchParams(location.search)

		if (params.get('source') === 'extension') {
			if (user) setShowLoginPrompt(true)

			const token = params.get('token')
			setToken(token)

			setSourceExtension(true)
		}
	}, [location.search])

	const routes = useRoutes([
		{
			path: '/',
			element: <AuthRedirect condition={user} element={<LandinPage />} />,
		},
		{
			path: '/account/login',
			element: showLoginPrompt ? (
				<Navigate to={`/login-prompt${location.search}`} />
			) : (
				<AuthRedirect
					condition={user && !sourceExtension}
					element={
						<Login
							sourceExtension={sourceExtension}
							setSourceExtension={setSourceExtension}
							windowOpender={window.opener}
							userToken={token}
						/>
					}
				/>
			),
		},
		{
			path: '/login-prompt',
			element: (
				<LoginPrompt userToken={token} sourceExtension={sourceExtension} />
			),
		},

		{
			path: '/account/signup',
			element: (
				<AuthRedirect
					condition={user}
					element={
						<SignUp
							sourceExtension={sourceExtension}
							setSourceExtension={setSourceExtension}
							windowOpender={window.opener}
							userToken={token || null}
						/>
					}
				/>
			),
		},
		{
			path: '/policy',
			element: <Policy />,
		},
		{
			path: '/terms',
			element: <Terms />,
		},
		{
			path: '/uninstall-feedback',
			element: <UninstallFeedback />,
		},
		{
			path: '/password-reset-request',
			element: (
				<PasswordResetRequest
					sourceExtension={sourceExtension}
					userToken={token}
				/>
			),
		},
		{
			path: '/password-reset/:token',
			element: <PasswordReset />,
		},

		{
			path: '/loadboard',
			element:
				user && sourceExtension ? (
					<Navigate to={`/login-prompt${location.search}`} />
				) : (
					<ProtectedRoute condition={user} element={<Loadboard />} />
				),
		},
		{
			path: '/payment',
			element: <ProtectedRoute condition={user} element={<PaymentPage />} />,
		},
		{
			path: '/payment-success',
			element: <PaymentSuccess />,
		},
		{
			path: '/settings',
			element: <ProtectedRoute condition={user} element={<Settings />} />,
		},
		{
			path: '/settings/devices',
			element: <ProtectedRoute condition={user} element={<Settings />} />,
		},
		{
			path: '/settings/team',
			element: <ProtectedRoute condition={user} element={<Settings />} />,
		},
		{
			path: '/settings/security',
			element: <ProtectedRoute condition={user} element={<Settings />} />,
		},
		{
			path: '/settings/telegram',
			element: <ProtectedRoute condition={user} element={<Settings />} />,
		},
		{
			path: '/analytics',
			element: (
				<ProtectedRoute condition={user} element={<AnalyticsDashboard />} />
			),
		},

		{
			path: '/admin/users',
			element: (
				<ProtectedRoute condition={user && isAdmin} element={<AdminUsers />} />
			),
		},

		{
			path: '*',
			element: user ? (
				<Navigate to="/loadboard" replace />
			) : (
				<Navigate to="/" replace />
			),
		},
	])

	return routes
}

export default Routes
